var Card = function (card) {
	function mapData(card) {
		"use strict";
		card.media = card.media.reduce(function(result, item) {
			result[item.type] = item.url;
			return result;
		}, {});
		// Alternative implementation for Array.prototype.reduce in this case
		// var tempMedia = {};
		// card.media.forEach(function(item) {
		// 	   tempMedia[item.type] = item.url;
		// });
		// card.media = tempMedia;
		return card;
		// TODO: create real domain object here to assure it does have all the required properties (map properties from data to domain object properties)
	}

	Object.assign(this, mapData(card));
};

module.exports = Card;



// WEBPACK FOOTER //
// ./src/assets/js/domain/Card.js